export enum ExternalStorageFooterVariant {
  Secure = 'secure',
  ConnectDms = 'connect-dms',
}

export enum ExternalStorageMenuState {
  ConnectedAccount = 'connected-account',
  EnabledNoConnectedAccount = 'enabled-no-connected-account',
  Disabled = 'disabled',
}
